import React from 'react';
import { SvgIcon } from '../svg-icon';

export const ArrowKeyboardRight = props => (
  <SvgIcon {...props} width="8" height="12" viewBox="0 0 8 12" fill="none">
    <path d="M0.590001 1.41L5.17 6L0.59 10.59L2 12L8 6L2 -5.24537e-07L0.590001 1.41Z" />
  </SvgIcon>
);
